import { AxiosBaseQueryFunction } from 'api/axiosBaseQuery';

import { TypedUseQueryHookResult } from '@reduxjs/toolkit/dist/query/react';
import { skipToken } from '@reduxjs/toolkit/query';

import { useGetWaterfallLaborFeeQuery } from './waterfallLaborService';

import { CommonProductQueryParams } from '~/api/easy-estimator-api/commonProductQueryParams';
import { useSelectedStore } from '~/api/easy-estimator-api/stores-api/useSelectedStore';
import { WaterfallLabor } from '~/core/models';
import { useAppSelector } from '~/redux/hooks';
import { selectSelectedColor } from '~/redux/slices/color';
import { selectZipcode } from '~/redux/slices/zipcode';

type UseWaterfallLaborReturn = TypedUseQueryHookResult<
  WaterfallLabor,
  CommonProductQueryParams,
  AxiosBaseQueryFunction
> & {
  waterfallLaborFee?: WaterfallLabor;
  isFetchingWaterfallLaborFee: boolean;
  isErrorWaterfallLaborFee: boolean;
};

export const useWaterfallLabor = (): UseWaterfallLaborReturn => {
  const zipCode = useAppSelector(selectZipcode);
  const selectedColor = useAppSelector(selectSelectedColor);
  const selectedStore = useSelectedStore();
  const shouldFetchWaterfallLaborFee =
    zipCode && selectedStore?.companyId && selectedColor?.qteGrpID;

  const { waterfallLaborFee, ...rest } = useGetWaterfallLaborFeeQuery(
    shouldFetchWaterfallLaborFee
      ? {
          params: {
            zipCode,
            storeId: selectedStore?.companyId,
            prodQteGrpID: selectedColor?.qteGrpID ?? undefined,
          },
        }
      : skipToken,
    {
      selectFromResult: (result) => ({
        waterfallLaborFee: result.isError ? undefined : result.data,
        ...result,
      }),
    }
  );

  return {
    waterfallLaborFee,
    isFetchingWaterfallLaborFee: rest.isFetching,
    isErrorWaterfallLaborFee: rest.isError,
    ...rest,
  };
};
